import ModalStories from '@entities/Stories/ui/modal'
import styles from '@entities/Stories/ui/modal/styles.module.scss'

import { useModalStore } from '@features/modal'




export default function useStoriesModal () {
  const { openModal, closeModal } = useModalStore()

  const openStoriesModal = (id: string) => {
    openModal('stories', <ModalStories showStartId={id} />, {
      classes: {
        content: styles['modal-content'],
      },
      hideIconClose: true,
    })
  }

  const closeStoriesModal = () => {
    closeModal('stories')
  }

  return {
    openStoriesModal,
    closeStoriesModal,
  }
}
